import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Transition } from 'semantic-ui-react';
import { PILink } from '../nav';
import { setBranch } from '../../actions/BusinessActions';
import { useTransition } from '../../hooks';

import './Branch.scss';

const Branch = (props) => {
    const { branch } = props;
    const dispatch = useDispatch();
    const visible = useTransition();

    return (
        <Transition
            animation={'fade down'}
            duration={300}
            visible={visible}
        >
            <Button className="pi branch-btn" as={PILink} to={`/order`} onClick={() => dispatch(setBranch(branch))}>
                <div>{branch.name}</div>
                <span>{branch.address}</span>
            </Button>
        </Transition>
    );
};

Branch.propTypes = {
    branch: PropTypes.object
};

export default Branch;
